import { useAuth } from "../contexts/AuthContext";
import { useChatAccess } from "../pages/Chat/useChatAccess";
import { ROUTES_NAMES } from "../components/routes";
import { canAccessExplorerPanel } from "../pages/Explorer/explorerTabs";

/** Landing route when chat is not available; never returns a /chat path. */
export function useNonChatHomeRoute(): string {
  const { getDefaultRoute, hasProductAccess, hasAnyExplorerAccess } = useAuth();
  const fallback = getDefaultRoute();
  if (!fallback.startsWith(ROUTES_NAMES.CHAT)) return fallback;
  if (hasProductAccess("micontenido")) return ROUTES_NAMES.MI_CONTENIDO;
  if (hasProductAccess("mispodcasts")) return ROUTES_NAMES.MIS_PODCASTS;
  if (hasAnyExplorerAccess()) return ROUTES_NAMES.EXPLORER_PANEL;
  return ROUTES_NAMES.SETTINGS;
}

/** Where `/` sends a signed-in user: Mi panel with any Explorer access, else Chat, else their product default. */
export function useHomeRoute(): { route: string; isLoading: boolean } {
  const { hasExplorerTabAccess } = useAuth();
  const { access, isLoading } = useChatAccess();
  const nonChatRoute = useNonChatHomeRoute();
  if (canAccessExplorerPanel(hasExplorerTabAccess)) {
    return { route: ROUTES_NAMES.EXPLORER_PANEL, isLoading: false };
  }
  if (isLoading) return { route: nonChatRoute, isLoading: true };
  return {
    route: access?.allowed ? ROUTES_NAMES.CHAT : nonChatRoute,
    isLoading: false,
  };
}
